var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9635 24.4674L0.480701 13.671C0.160209 13.3425 0 12.9209 0 12.499C0 12.0773 0.160282 11.6559 0.480701 11.327L10.9635 0.530655C11.6316 -0.15122 12.7444 -0.179632 13.4491 0.46673C14.1588 1.11487 14.1838 2.19841 13.5178 2.87745L4.11179 12.5018L13.5178 22.1262C14.1838 22.8053 14.1589 23.8814 13.4491 24.5341C12.7444 25.1798 11.6316 25.1514 10.9635 24.4674Z",
    fill: "#100E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowOptionsIcon);
export default __webpack_public_path__ + "static/media/showOptionsIcon.fff188dcad8dc58d40a86b65c9308108.svg";
export { ForwardRef as ReactComponent };